// env-info.ts
import { baseConfig } from "@adornis/config/baseConfig";
import { Environment } from "@adornis/config/environment-checks";
import { Capacitor } from "@capacitor/core";
import { ObjectId } from "mongodb";
import { BehaviorSubject, fromEvent, map, merge, of, shareReplay, startWith } from "rxjs";
var globalIDIncrement = 0;
var onlineOfflineObservable;
var A = {
  isClient: [Environment.BROWSER, Environment.SERVICEWORKER].includes(baseConfig.get("ENVIRONMENT")),
  isServer: baseConfig.get("ENVIRONMENT") === Environment.NODE,
  isServiceWorker: baseConfig.get("ENVIRONMENT") === Environment.SERVICEWORKER,
  get isNative() {
    return Capacitor.isNative;
  },
  get isIOS() {
    return Capacitor.getPlatform() === "ios";
  },
  get isAndroid() {
    return Capacitor.getPlatform() === "android";
  },
  isDevelopment: baseConfig.get("DEPLOYMENT") === "development",
  isProduction: baseConfig.get("DEPLOYMENT") !== "development",
  isOnline: new BehaviorSubject(baseConfig.get("ENVIRONMENT") === Environment.BROWSER ? navigator.onLine : true),
  absoluteUrl: (path = "/", params) => {
    const root = baseConfig.get("ROOT_URL");
    const url = new URL(path, root);
    if (params)
      url.search = params.toString();
    return url.toString();
  },
  getGloballyUniqueID() {
    if (A.isServer)
      return new ObjectId().toHexString();
    const time4Byte = Math.floor(Date.now() / 1e3).toString(16);
    const random5Byte = Array.from(window.crypto.getRandomValues(new Uint8Array(5))).map((num) => ("0" + num.toString(16)).slice(-2)).join("");
    const randomAndIncrement3Byte = ("000" + (window.crypto.getRandomValues(new Uint8Array(3)).reduce((acc, curr) => acc * curr, 1) + globalIDIncrement).toString(16)).slice(-3);
    return time4Byte + random5Byte + randomAndIncrement3Byte;
  },
  online() {
    if (A.isServer)
      return of(true);
    return (onlineOfflineObservable ?? (onlineOfflineObservable = merge(
      fromEvent(window, "online").pipe(map(() => true)),
      fromEvent(window, "offline").pipe(map(() => false))
    ))).pipe(startWith(navigator.onLine), shareReplay(1));
  }
};
export {
  A
};
